import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { publicApi } from "@/lib/api";
import { FanDots } from "@/components/site/FanDots";

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

export const FanWall = () => {
  const [wall, setWall] = useState(null);
  useEffect(() => { publicApi.get("/public/fan-wall").then(({ data }) => setWall(data)).catch(() => {}); }, []);
  if (!wall?.show) return null;
  const parts = [];
  if (wall.states >= 2) parts.push(plural(wall.states, "state"));
  if (wall.countries >= 2) parts.push(`${wall.countries} countries`);
  const where = parts.join(" and ");
  return (
    <div className="mt-4" data-testid="fan-wall">
      <p className="font-caps text-ash inline-flex items-center gap-2 justify-center" style={{ fontSize: ".6rem", letterSpacing: ".18em" }} data-testid="fan-wall-line">
        <Heart size={11} fill="var(--rose)" color="var(--rose)" /> Fans in {where} are already on the list
      </p>
      {wall.map && (
        <div className="mx-auto mt-4" style={{ maxWidth: 420 }} data-testid="fan-wall-map">
          <FanDots dots={wall.map.dots} height={140} testid="fan-wall-dots" />
          <p className="font-caps text-ash mt-2" style={{ fontSize: ".5rem", letterSpacing: ".16em" }}>
            {wall.map.places.map((p) => `${p.name} · ${p.count}`).join("   ")}
          </p>
        </div>
      )}
    </div>
  );
};
